import { Component, Input } from '@angular/core';
import { IExpert } from '@techspert-io/experts';
import { AppService } from '../../../../../../../shared/services/app.service';
import { PhoneService } from '../../../../../../../shared/services/phone.service';

@Component({
  selector: 'app-contact-info-box',
  templateUrl: './contact-info-box.component.html',
  styleUrls: ['./contact-info-box.component.scss'],
  standalone: false,
})
export class ContactInfoBoxComponent {
  @Input() expert: IExpert;

  constructor(
    public appService: AppService,
    private phoneService: PhoneService
  ) {}

  get primaryEmail() {
    return this.expert.primaryEmail
      ? this.formatEmail(this.expert.primaryEmail)
      : undefined;
  }

  get emails() {
    return this.expert.opportunityEmails.map((email) =>
      this.formatEmail(email)
    );
  }

  get primaryPhoneNumber() {
    return this.expert.primaryPhoneNumber
      ? this.formatNumber(this.expert.primaryPhoneNumber)
      : undefined;
  }

  get numbers() {
    return (this.expert.phoneNumbers || []).map((phoneNumber) =>
      this.formatNumber(phoneNumber)
    );
  }

  get linkedInDisplayUrl(): string | undefined {
    return (
      this.expert.primaryLinkedInUrl ||
      this.validOtherLinkedInUrls.find(Boolean)
    );
  }

  get linkedInOverflowUrls(): string[] {
    if (this.expert.primaryLinkedInUrl) {
      return [];
    }
    return this.validOtherLinkedInUrls.slice(1);
  }

  private get validOtherLinkedInUrls(): string[] {
    return this.expert.otherLinkedInUrls?.filter(Boolean) || [];
  }

  private formatEmail(email: string) {
    return { value: email, isInvalid: false };
  }

  private formatNumber(phoneNumber: string) {
    const formatted = this.phoneService.formatNumber(
      phoneNumber,
      this.expert.country
    );

    return {
      value: formatted.number,
      isInvalid: !formatted.isValid,
    };
  }
}
